import { BaseEntity } from "yt-ng-framework";
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

export class DokumentStavkaView extends BaseEntity{
    constructor(){
        super();
    }

    Valuta: string=null;
    IznosValute: number=null;
    IznosPoKursuTrans: number=null;
    IznosPoSrednjemKursu: number=null;
    KursnaRazlika:number=null;
    PocetnoStanje: number = null;
    KupovinaOdBanke: number = null;
    UlazSaDeviznogRacuna: number = null;
    InterniUlaz: number = null;
    Zamena: number = null;
    InterniIzlaz: number = null;
    IzlazNaDevizniRacun: number = null;
    ProdajaBanci: number = null;
    ProdajaBanciObavezi: number = null;

    Deserialize(input:any){
        this.ID=input.ID;
        this.Valuta=input.Valuta;
        this.IznosValute=input.IznosValute;
        this.IznosPoKursuTrans=input.IznosPoKursuTrans;
        this.IznosPoSrednjemKursu=input.IznosPoSrednjemKursu;
        this.KursnaRazlika=input.KursnaRazlika;
        this.PocetnoStanje = input.PocetnoStanje;
        this.KupovinaOdBanke = input.KupovinaOdBanke;
        this.UlazSaDeviznogRacuna = input.UlazSaDeviznogRacuna;
        this.InterniUlaz = input.InterniUlaz;
        this.Zamena = input.Zamena;
        this.InterniIzlaz = input.InterniIzlaz;
        this.IzlazNaDevizniRacun = input.IzlazNaDevizniRacun;
        this.ProdajaBanci = input.ProdajaBanci;
        this.ProdajaBanciObavezi = input.ProdajaBanciObavezi;

        return this;
    }
    Serialize(input:DokumentStavkaView){
        return input;
    }
}